import styled from '@emotion/styled';

export const Wrapper = styled.ul`
  list-style: none;
  line-height: 1.7;
  text-align: left;
`;

export const Icon = styled.img`
  height: 16px;
  left: 0;
  position: absolute;
  top: 3px;
  width: 16px;
`;

export const Item = styled.div`
  padding-left: 30px;
  position: relative;
  margin: 20px 0;
  line-height: 1.7;
`;
